import type { LocalPermissions, LocalPermissionsListParams } from '@/libs/interfaces'

import { MOCK_ORG_ID, mockPermissions } from '../fixtures/seed'
import { delay, genID, matchesSearch } from '../helpers'
import { createEntityStore } from '../store'

const permissionStore = createEntityStore<LocalPermissions, 'permissionID'>(
  mockPermissions,
  'permissionID',
)

const filterPermissions = (params: LocalPermissionsListParams): LocalPermissions[] =>
  permissionStore
    .getAll()
    .filter((permission) =>
      matchesSearch(permission, params.search, ['permDispName', 'permissionTitle']),
    )

export const permissionsApiMock = {
  create: async (body: Partial<LocalPermissions>): Promise<Partial<LocalPermissions>> => {
    const permission: LocalPermissions = {
      permissionID: genID('permission'),
      orgID: MOCK_ORG_ID,
      ...body,
    }
    permissionStore.insert(permission)
    return delay(permission)
  },
  getByID: async (params: Partial<LocalPermissions>): Promise<Partial<LocalPermissions>> =>
    delay(permissionStore.getById(params.permissionID ?? '') ?? {}),
  list: async (params: LocalPermissionsListParams): Promise<LocalPermissions[]> =>
    delay(filterPermissions(params)),
  listAll: async (params: LocalPermissionsListParams): Promise<LocalPermissions[]> =>
    delay(filterPermissions(params)),
  update: async (payload: Partial<LocalPermissions>) => {
    const updated = payload.permissionID
      ? permissionStore.update(payload.permissionID, payload)
      : undefined
    return delay(updated ?? payload)
  },
  delete: async (payload: Partial<LocalPermissions>) => {
    if (payload.permissionID) permissionStore.remove(payload.permissionID)
    return delay(undefined)
  },
}
